<template>
  <div class="not-found-page">
    
    <nav class="navbar navbar-transparent navbar-absolute">
      <div class="container">
        <div class="navbar-header">
        </div>
        <div class="collapse navbar-collapse">
          <ul class="nav navbar-nav navbar-right">
            <li>
              <router-link to="/admin/overview">
                <i class="nc-icon nc-chart-pie-35"></i> Dashboard
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <div class="wrapper wrapper-full-page d-flex align-items-center">
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-md-offset-2 text-center">
            
            <h1 class="title-404">404</h1>
            
            <h4 class="description text-muted">
              Page not found
            </h4>
            <p class="details text-muted">
              The page you requested could not be found. 
            </p>

            <div class="margin-top-30">
              <router-link :to="{path:'/'}" class="btn btn-info btn-fill btn-wd">
                Back to Dashboard
              </router-link>
            </div>

          </div>
        </div>
      </div>
    </div>

    <footer class="footer footer-transparent">
      <div class="container">
        <div class="copyright text-center">
          &copy; {{ new Date().getFullYear() }} НИЯУ МИФИ
        </div>
      </div>
    </footer>

  </div>
</template>

<script>
  export default {
    name: 'NotFoundPage'
  }
</script>

<style lang="scss" scoped>
/* 1. Main Wrapper: Forces content to center */
.wrapper-full-page {
  display: flex;             /* Turn on Flexbox */
  align-items: center;       /* Center vertically */
  justify-content: center;   /* Center horizontally */
  min-height: 100vh;         /* Force it to take full screen height */
  width: 100%;
  position: relative;
  background-color: #f5f5f5; /* Light grey background */
}

/* 2. Navbar Styling */
.navbar-transparent {
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 10;
  border: none;
  background: transparent;
}

.navbar-brand {
  color: #66615b !important;
  font-weight: 600;
  font-size: 18px;
  text-transform: uppercase;
}

/* 3. Text Typography */
.title-404 {
  font-size: 100px; /* Adjusted size for better mobile fit */
  font-weight: 700;
  color: #404040;
  margin-bottom: 0;
  line-height: 1;
}

.description {
  font-size: 24px;
  font-weight: 300;
  margin-top: 15px;
  color: #9a9a9a;
}

.details {
  font-size: 14px;
  margin-bottom: 30px;
  color: #9a9a9a;
}

/* 4. Footer Styling */
.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 20px 0;
}
.copyright {
  color: #a9a9a9;
  font-size: 13px;
}

/* 5. Button Styling */
.btn-info.btn-fill {
  background-color: #1dc7ea;
  border-color: #1dc7ea;
  opacity: 1;
  border-radius: 4px;
  padding: 10px 20px;
  
  &:hover {
    background-color: #19b5d5;
    border-color: #19b5d5;
  }
}
</style>